"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentStatus = void 0;
/**
 * statusCode: "AC" | "IT" | "DE" | "EX" | "AT" | "UN";
 * statusDescription: "Accepted" | "Attempted Delivery" | "Delivered" | "Exception" | "In Transit" | "Unknown";
 */
// shipengine statuses
// Status_code	Status_description	Tracking_status
// AC	Accepted	N/A
// IT	In Transit	in_transit
// DE	Delivered	delivered
// EX	Exception	error
// UN	Unknown	unknown
// AT	Delivery Attempt	N/A
// NY	Not Yet In System	in_transit
// SP	Delivered To The Collection Location	delivered_to_service_point
// Shipengine 	Toolkit Shipment tracking status 	Toolkit Order status
// AC - Accepted - N/A	Packaged received by courier 	Delivery in progress
// IT- In Transit - in_transit	In transit 	Delivery in progress
// DE - Delivered - delivered	Delivered 	Delivered
// EX- Exception - error	Status error 	IGNORE
// UN - Unknown - unknown	Status unknown 	IGNORE
// AT - Delivery Attempt 	Delivery attempt 	Delivery in progress
// NY - Not Yet In System - in_transit	In transit 	Delivery in progress
// SP - Delivered To The Collection Location - delivered_to_service_point	Delivered to the collection point 	Delivered
// export enum ShippengineTrackingStatusCodes {
//   ACCEPTED = "AC",
//   IN_TRANSIT = "IT",
//   DELIVERED = "DE",
//   EXCEPTION = "EX",
//   UNKNOWN = "UN",
//   DELIVERY_ATTEMPT = "AT",
//   NOT_YET_IN_SYSTEM = "NY",
//   DELIVERED_TO_COLLECTION_LOCATION = "SP",
// }
// Status_code	Status_description	Tracking_status
// AC	Accepted	N/A
// IT	In Transit	in_transit
// DE	Delivered	delivered
// EX	Exception	error
// UN	Unknown	unknown
// AT	Delivery Attempt	N/A
// NY	Not Yet In System	in_transit
// SP	Delivered To The Collection Location	delivered_to_service_point
var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["RECIEVED_BY_COURIER"] = "RECIEVED_BY_COURIER";
    ShipmentStatus["DELIVERED_TO_SERVICE_POINT"] = "DELIVERED_TO_SERVICE_POINT";
    ShipmentStatus["IN_TRANSIT"] = "IN_TRANSIT";
    ShipmentStatus["DELIVERY_ATTEMPT"] = "DELIVERY_ATTEMPT";
    ShipmentStatus["DELIVERED"] = "DELIVERED";
})(ShipmentStatus = exports.ShipmentStatus || (exports.ShipmentStatus = {}));
